import * as React from 'react';
import { resolveBrowserLocale } from 'react-admin';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import * as raEn from 'ra-language-english';
import * as raNl from 'ra-language-dutch';
import frenchMessages from 'ra-language-french';
import _ from 'lodash';
import { formalGermanMessages } from '@haleos/ra-language-german';
import en from '../../config/i18n/locales/en';
import nl from '../../config/i18n/locales/nl';
import de from '../../config/i18n/locales/de';
import fr from '../../config/i18n/locales/fr';
import {
  DutchFlag, EnglishFlag, FrenchFlag, GermanFlag,
} from '../../components/locales/Flags';

const translations = {
  en: _.merge(raEn.default, en),
  nl: _.merge(raNl.default, nl),
  de: _.merge(formalGermanMessages, de),
  fr: _.merge(frenchMessages, fr),
};

export const i18nProvider = polyglotI18nProvider(
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  (locale) => (translations[locale] ? translations[locale] : translations.en),
  resolveBrowserLocale(),
  [
    { locale: 'en', name: <EnglishFlag/> },
    { locale: 'nl', name: <DutchFlag/> },
    { locale: 'de', name: <GermanFlag/> },
    { locale: 'fr', name: <FrenchFlag/> },
  ],
  { allowMissing: true },
);
